/* src/app/components/change-text-field-modal/change-text-field-modal.component.scss */
.inner-content {
  padding: 30px;
}
.textarea-container ion-label {
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 10px;
}
.textarea-container ion-textarea {
  --padding-top: 16px;
  --padding-start: 10px;
  --padding-end: 10px;
  --padding-bottom: 10px;
  --background: white;
  --border-radius: 10px;
  --border-width: 1px;
  --border-color: #6f6f6f !important;
  font-weight: 400;
  font-size: 16px;
}
.textarea-container ion-button {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}
ion-icon {
  width: 24px;
  height: 24px;
}
ion-icon.title-icon {
  width: 30px;
  height: 30px;
}
.title {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 24px;
  font-weight: 500;
}
hr {
  margin-top: 30px;
  margin-bottom: 30px;
  border-top: 1px solid #cbcbcb;
}
.label {
  font-size: 18px;
  font-weight: 500;
}
/*# sourceMappingURL=change-text-field-modal.component-56GKMSNG.css.map */
